import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const API_URL = "https://nuvolahub.in/gymprojects/gymapi/reactcrud.php";

export default function Crud() {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({
    id: "",
    name: "",
    email: "",
    password: "",
    imageFile: null,
    imagePath: "",
  });
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);

  // Fetch all users
  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await fetch(API_URL);
      const text = await res.text();
      const data = JSON.parse(text);
      setUsers(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Fetch Error", err);
      toast.error("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "imageFile") {
      setForm((prev) => ({ ...prev, imageFile: files?.[0] || null }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Add or Update User
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.password) {
      toast.warn("Name, email and password are required");
      return;
    }

    if (isEditing) {
      try {
        const res = await fetch(API_URL, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: form.id,
            name: form.name,
            email: form.email,
          }),
        });
        const data = await res.json();
        if (data.status) {
          toast.success(data.message || "Updated!");
          resetForm();
          fetchUsers();
        } else toast.error(data.message || "Update failed");
      } catch (err) {
        console.error(err);
        toast.error("Error updating user");
      }
    } else {
      const fd = new FormData();
      fd.append("name", form.name);
      fd.append("email", form.email);
      fd.append("password", form.password);
      if (form.imageFile) fd.append("image", form.imageFile);

      try {
        const res = await fetch(API_URL, { method: "POST", body: fd });
        const txt = await res.text();
        const data = JSON.parse(txt);
        if (data.status) {
          toast.success(data.message || "Added!");
          resetForm();
          fetchUsers();
        } else toast.error(data.message || "Add failed");
      } catch (err) {
        console.error(err);
        toast.error("Error adding user");
      }
    }
  };

  // Delete user
  const handleDelete = async (id) => {
    toast.info("Deleting user...");
    try {
      const res = await fetch(API_URL, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });
      const data = await res.json();
      if (data.status) {
        toast.success(data.message || "Deleted!");
        fetchUsers();
      } else toast.error(data.message || "Delete failed");
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete user");
    }
  };

  // Prepare form for editing
  const handleEdit = (user) => {
    setIsEditing(true);
    setForm({
      id: user.id,
      name: user.name,
      email: user.email,
      password: user.password,
      imageFile: null,
      imagePath: user.image || "",
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const resetForm = () => {
    setIsEditing(false);
    setForm({
      id: "",
      name: "",
      email: "",
      password: "",
      imageFile: null,
      imagePath: "",
    });
  };

  return (
    <div style={{ maxWidth: 800, margin: "auto", padding: 20 }}>
      <form onSubmit={handleSubmit} style={{ marginBottom: 30 }}>
        <h2>{isEditing ? "Edit User" : "Add New User"}</h2>

        <input
          type="text"
          name="name"
          value={form.name}
          onChange={handleChange}
          placeholder="Name"
          required
        />
        <br /><br />

        <input
          type="email"
          name="email"
          value={form.email}
          onChange={handleChange}
          placeholder="Email"
          required
        />
        <br /><br />

        <input
          type="password"
          name="password"
          value={form.password}
          onChange={handleChange}
          placeholder="Password"
          required
        />
        <br /><br />

        <input type="file" name="imageFile" onChange={handleChange} />
        <br /><br />

        <input
          type="text"
          name="imagePath"
          value={form.imagePath}
          onChange={handleChange}
          placeholder="Or Image URL"
        />
        <br /><br />

        <button type="submit">{isEditing ? "Update" : "Add"}</button>
        {isEditing && (
          <button type="button" onClick={resetForm} style={{ marginLeft: 10 }}>
            Cancel
          </button>
        )}
      </form>

      <h2>Users List</h2>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <table border="1" cellPadding="8" width="100%">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Password</th>
              <th>Image</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id}>
                <td>{u.id}</td>
                <td>{u.name}</td>
                <td>{u.email}</td>
                <td>{u.password}</td>
                <td>
                  {u.image ? (
                    <img
                      src={`https://nuvolahub.in/gymprojects/gymapi/${u.image}`}
                      alt={u.name}
                      style={{ width: 50, height: 50, objectFit: "cover" }}
                    />
                  ) : (
                    "No image"
                  )}
                </td>
                <td>
                  <button onClick={() => handleEdit(u)}>Edit</button>{" "}
                  <button onClick={() => handleDelete(u.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
